<template>
  <v-client-table :data="filters" :columns="columns" :options="options" style="margin-bottom: 4rem;">
    <div slot="color" slot-scope="props">
      <rgb-display v-bind:rgb="props.row"></rgb-display>
    </div>

    <div slot="baseline" slot-scope="props">
      <font-awesome-icon v-if="props.row.baseline" icon="check-circle"/>
    </div>
  </v-client-table>
</template>

<script>
  import RgbDisplay from '../utils/RgbDisplay';

  export default {
    name: 'ResultTable',
    components: { RgbDisplay },
    props: ['filters'],
    data() {
      return {
        columns: ['sortOrder', 'name', 'color', 'rating', 'baseline'],
        options: {
          filterable: false,
          pagination: { dropdown: false },
          perPage: 40,
          perPageValues: [],
          headings: {
            name: 'Filter Name',
            baseline: 'Is Baseline?',
            sortOrder: 'Test Order',
          },
          sortable: ['sortOrder', 'filterName', 'rating', 'baseline'],
          sortIcon: { base: 'fa', up: 'fa-sort-up', down: 'fa-sort-down', is: 'fa-sort' },
          columnsDisplay: {
            "color": "not_mobile",
            "baseline": "not_mobile",
          },
        },
      };
    },
  };
</script>

<style scoped>

</style>
